import React from 'react';
import PublicStaticLayout from '../components/PublicStaticLayout';

export default function PolitiqueConfidentialitePage() {
  return (
    <PublicStaticLayout title="Politique de confidentialité">
      <p>
        La présente politique décrit comment l&apos;application <strong>Baromètre Social Temps Réel</strong>{' '}
        traite les données à caractère personnel, dans le respect du Règlement général sur la
        protection des données (RGPD) et de la loi « Informatique et libertés ».
      </p>

      <h2>Responsable du traitement</h2>
      <p>
        Le responsable du traitement est l&apos;organisation qui déploie l&apos;application pour
        son usage interne (employeur, association, collectivité, etc.). Les éditeurs de
        l&apos;application —{' '}
        <a href="https://www.webmonster.tech" target="_blank" rel="noopener noreferrer">
          Collectif Webmonster
        </a>{' '}
        et{' '}
        <a href="https://www.numera11y.fr" target="_blank" rel="noopener noreferrer">
          numera11y
        </a>{' '}
        — peuvent agir en tant que sous-traitants techniques selon les contrats en place.
      </p>

      <h2>Données collectées</h2>
      <ul>
        <li>
          <strong>Comptes administrateurs</strong> : identifiants de connexion, nom, rôle,
          service ou site le cas échéant, nécessaires à la gestion des sondages et des rapports.
        </li>
        <li>
          <strong>Réponses aux micro-sondages</strong> : collectées de manière anonymisée ou
          pseudonymisée selon la configuration du sondage, pour mesurer le climat social.
        </li>
        <li>
          <strong>Données techniques</strong> : journaux, adresse IP, type de navigateur, dans
          la limite nécessaire à la sécurité et au bon fonctionnement du service.
        </li>
      </ul>

      <h2>Finalités</h2>
      <p>
        Les données servent à fournir le service (authentification, création de sondages,
        agrégation des résultats, alertes), à améliorer la fiabilité de la plateforme et à
        respecter les obligations légales.
      </p>

      <h2>Durée de conservation</h2>
      <p>
        Les durées de conservation sont définies par le responsable du traitement et documentées
        dans le registre des traitements de l&apos;organisation. Les comptes inactifs peuvent être
        désactivés conformément à la politique interne.
      </p>

      <h2>Vos droits</h2>
      <p>
        Vous disposez d&apos;un droit d&apos;accès, de rectification, d&apos;effacement, de
        limitation, d&apos;opposition et de portabilité lorsque ces droits s&apos;appliquent.
        Pour les exercer, adressez-vous au responsable du traitement (votre organisation) ou, le
        cas échéant, au délégué à la protection des données (DPO) désigné par celle-ci.
      </p>

      <h2>Réclamations</h2>
      <p>
        Vous pouvez introduire une réclamation auprès de la CNIL (
        <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">
          cnil.fr
        </a>
        ).
      </p>
    </PublicStaticLayout>
  );
}
